import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from 'components/v4';

function ConvertRaModal({
    finalRef,
    handleConvert,
    isLoading,
    isOpen,
    onClose,
    walkthroughIds,
}) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            closeOnOverlayClick={false}
            motionPreset="scale"
            isCentered
            finalFocusRef={finalRef}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Convert RA to User?</ModalHeader>
                <ModalBody>
                    <Text>
                        Are you sure you would like to convert this resource
                        account to a user account?
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button
                        colorScheme="primary"
                        variant="outline"
                        width="80px"
                        mr={4}
                        onClick={onClose}
                        data-walkthroughid={walkthroughIds.admin.ufNoBtn}>
                        No
                    </Button>
                    <Button
                        colorScheme="red"
                        width="80px"
                        isLoading={isLoading}
                        onClick={handleConvert}
                        data-walkthroughid={walkthroughIds.admin.ufYesBtn}>
                        Yes
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
export default ConvertRaModal;
